  <template>
  <div class="animated revealUp">
    <div class="white-wrapper">
      <div class="section-title mb-4">{{ $t("expiryreport") }}</div>
      <div class="mt-3 mb-2">
        <div class="row">
          <!-- SELECT DROPDOWN -->
          <div class="col-lg-4 col-xl-3 align-self-center mb-4">
            <div class="dropdown-curve-container mr-2">
              <label :class="getExpiryReportsSelectedCinema ? 'shift-up' : ''"
                >{{ $t("select") }} {{ $tc("cinema", 1) }}</label
              >
              <b-dropdown
                :text="getExpiryReportsSelectedCinema"
                variant="dropdown-curve"
                class="w-100"
                :disabled="isRoleID"
              >
                <div class="px-2 pb-2">
                  <input
                    required
                    autofocus
                    type="search"
                    :placeholder="$tc('searchCinema')"
                    class="form-control form-control-sm"
                    v-on:keyup="onSearchCinema()"
                    v-on:keydown="onSearchCinema()"
                    v-on:search="onSearchCinema()"
                    v-model="searchCinema"
                  />
                </div>
                <b-dropdown-item
                  v-for="(dropdownItem, dropdownIndex) in Cinemas"
                  :key="dropdownIndex"
                  @click="
                    onExpiryReportDropDownHandler({
                      event: $event,
                      name: 'isCinema',
                      selectedItem: dropdownItem,
                      index: dropdownIndex
                    });
                    searchCinema = '';
                    onSearchCinema();
                    onSelectCinema(dropdownItem);
                  "
                  >{{ dropdownItem.cine_name }}</b-dropdown-item
                >
              </b-dropdown>
            </div>
          </div>
          <!-- <div class="col-lg-4 col-xl-3 align-self-center mb-4">
            <div class="input-material">
              <div class="add-datepicker">
                <button class="btn-clearDate">✖</button>
                <Datepicker :monday-first="true"
                  @selected="onExpiryReportDropDownHandler({ event: $event, name: 'fromDate' })"
                  :value="getExpiryReportFromDate"
                ></Datepicker>
                <label :class="getExpiryReportFromDate ? 'active': ''">{{ $t("startdate") }}</label>
              </div>
            </div>
          </div>-->

          <div class="col-lg-4 col-xl-3 align-self-center mb-4">
            <div class="input-material">
              <div class="add-datepicker">
                <button
                  v-if="getExpiryReportEndDate"
                  class="btn-clearDate"
                  @click="
                    onExpiryReportDropDownHandler({
                      event: null,
                      name: 'endDate'
                    })
                  "
                >
                  ✖
                </button>
                <Datepicker
                  :monday-first="true"
                  @selected="
                    onExpiryReportDropDownHandler({
                      event: $event,
                      name: 'endDate',
                    })
                  "
                  :value="getExpiryReportEndDate"
                  typeable
                ></Datepicker>
                <label :class="getExpiryReportEndDate ? 'active' : ''"
                  >{{ $t("expiry") }} {{ $t("till") }} {{ $t("date") }}</label
                >
              </div>
            </div>
          </div>

          <div class="col-lg-4 col-xl-3 align-self-center mb-4">
            <button @click="onFetchExpiryReport" class="btn-blue-lg w-100">
              {{ $tc("getReport") }}
            </button>
          </div>

          <div
          v-if="getExpiryReportData && getExpiryReportData.length > 0"
          class="col-lg-4 col-xl-3 mb-4 d-flex justify-content-end align-items-center"
        >
          <div>{{ $t("download") }} as:</div>
          <a
            v-if="getExpiryReportsPDFFileName"
            :href="BASE_URL + getExpiryReportsPDFFileName"
            target="_blank"
            download
            title="Download as PDF"
          >
            <img src="@/assets/img/icons/pdf-icon.svg" height="25" width="25" />
          </a>

          <a
            v-if="getExpiryReportsExcelFileName"
            :href="BASE_URL + getExpiryReportsExcelFileName"
            target="_blank"
            title="Download as Excel"
            download
          >
            <img src="@/assets/img/icons/excel.svg" height="25" width="25" />
          </a>
        </div>

        </div>
      </div>
      <div class="swc-report">
        <table class="swc-report-table w-100" border="1">
          <thead class>
            <tr class="bg-lightgrey">
              <th>{{ $t("item") }}</th>
              <th>{{ $tc("purchase") }} {{ $tc("order") }}</th>
              <th>{{ $tc("expiry") }} {{ $t("date") }}</th>
              <th>{{ $t("number") }} {{ $t("of") }} {{ $t("item") }}</th>
            </tr>
          </thead>
          <tbody v-if="getExpiryReportData.length > 0" class="sph-report">
            <tr
              v-for="(expiry, expiryIndex) in getExpiryReportData"
              :key="expiryIndex"
            >
              <td>{{ expiry.rm_name }}</td>
              <td>{{ expiry.po_number }}</td>
              <td v-if="expiry.stock_expiry_date_timestamp == 0">-</td>
              <td v-if="expiry.stock_expiry_date_timestamp != 0">
                {{ expiry.stock_expiry_date_timestamp | TimeStamptoDate }}
              </td>
              <td>{{ currFormat(expiry.remaining_quantity) }}</td>
            </tr>
          </tbody>

          <tbody v-else class="sph-report">
            <tr>
              <td colspan="4">
                <!-- No Records Found. -->
                <NoRecords />
              </td>
            </tr>
          </tbody>
        </table>

        
      </div>
    </div>
  </div>
</template>
<script>
import DatePicker from "vue2-datepicker";
import { mapState, mapGetters, mapActions } from "vuex";
import MasterService from "@/services/MasterService";
import NoRecords from "@/components/Partials/NoRecords.vue";

export default {
  components: { DatePicker, NoRecords },
  data() {
    return {
      Cinemas: [],
      isRoleID: true,
      CinemasCopy: [],
      searchCinema: ""
    };
  },
  computed: {
    ...mapGetters([
      "getCinemasList",
      "getExpiryReportsSelectedCinema",
      "getExpiryReportFromDate",
      "getExpiryReportEndDate",
      "getExpiryReportData",
      "getChartOptions",
      // EXCEL
      "getExpiryReportsExcelFileName",
      // PDF
      "getExpiryReportsPDFFileName"
    ])
  },
  mounted() {
    let roleid = this.secureStore.get("USINFO").role_id;
    if (true) {
      this.isRoleID = false;
    }
    let cinemaId =
      this.secureStore.get("USINFO") &&
      this.secureStore.get("USINFO")["cinema_id"]
        ? this.secureStore.get("USINFO").cinema_id
        : null;
    this.getCinemaList(cinemaId);
    // this.onExpiryReportDropDownHandler({
    //   event: null,
    //   name: "isCinema",
    //   value: null
    // });

    this.onExpiryReportDropDownHandler({
      event: null,
      name: "endDate",
      value: null
    });

    this.ClearReportData(null);

    this.fetchCinemasList({ cinemaId });

    let CinemaObj = this.$store.getters.getSelectedDropDownCinema;
    if (CinemaObj) {
      this.onExpiryReportDropDownHandler({
        event: null,
        name: "isCinema",
        selectedItem: CinemaObj
      });
    }
  },
  watch: {
    "$store.getters.getSelectedDropDownCinema": function(CinemaObj) {
      if (CinemaObj) {
        this.onExpiryReportDropDownHandler({
          event: null,
          name: "isCinema",
          selectedItem: CinemaObj
        });
      }
    }
  },
  methods: {
    onSelectCinema(cinema) {
      this.$store.dispatch("selectDropdownCinema", cinema);
    },
    onSearchCinema: function() {
      if (this.searchCinema && this.searchCinema.length > 0) {
        this.Cinemas = this.CinemasCopy.filter(x => {
          if (
            x.cine_name.toLowerCase().includes(this.searchCinema.toLowerCase())
          ) {
            return x;
          }
        });
      } else {
        this.Cinemas = this.CinemasCopy;
      }
    },
    getCinemaList: function(cine_id) {
      this.Cinemas = [];
      //  let payload = null
      //   cine_id == null ?  payload = {tableName : 'ms_cinemas',cine_is_active: "Y"} : payload = {tableName : 'ms_cinemas',cine_is_active: "Y" ,cine_id : cine_id }
      MasterService.GetCinemas({ cine_id: cine_id })
        .then(response => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.Cinemas = data.Records;
            this.CinemasCopy = data.Records;
            this.Cinemas.map(x => {
              if (String(cine_id) === String(x.cine_id)) {
                // let cinema = {
                //   cine_name: x.cine_name,
                //   cine_id: x.cine_id
                // };

                // this.onSelectCinema(null,cinema);
                this.onExpiryReportDropDownHandler({
                  name: "isCinema",
                  selectedItem: {
                    cine_name: x.cine_name,
                    cine_id: x.cine_id
                  }
                });
              }
            });
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },
    ...mapActions([
      //
      "fetchCinemasList",
      "onExpiryReportDropDownHandler",
      "ClearReportData",
      "onFetchExpiryReport"
    ])
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/Pages/ReportsContainer/ExpiryReport.vue